import { FC } from "react";
import { AnyTask, TaskRoute } from "tm-shared/types";

import { PointTaskItem } from "@/domains/point";
import { QueueTaskStatus } from "@/hooks";
import { useTaskPayloadSelector } from "@/hooks/redux";

interface TaskRowItemProps {
    task: AnyTask;
    onTaskClick: (task: AnyTask) => void;
    isTaskEnabled: (task: AnyTask) => boolean;
    status: QueueTaskStatus | null;
}

export const TaskRow: FC<TaskRowItemProps> = ({
    task,
    onTaskClick,
    isTaskEnabled,
    status,
}) => {
    const route = task.context.route;
    const isAccent = route === TaskRoute.CustomTask;

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error route can be outside progress-backed task routes here
    const taskPayload = useTaskPayloadSelector(route, task.id);

    const isTaskDirty = !!taskPayload && !task.completed;

    return (
        <PointTaskItem
            task={task}
            onTaskClick={onTaskClick}
            isTaskEnabled={isTaskEnabled}
            isTaskDirty={isTaskDirty}
            accent={isAccent}
            status={status}
        />
    );
};
